var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"document-model-modal","title":_vm.title,"size":"xl","hide-footer":"","scrollable":""}},[_c('LmFormBuilder',{staticClass:"px-0",attrs:{"endpointUriwhereGetComponents":_vm.formbuilderPath,"endpointUriWhereGetValuesToLoadInEditMode":_vm.dataPathOnEditMode,"isParentOnEditMode":"","isDisabled":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }